/**
 * List view local types (filters / sort / grouping / column ids).
 *
 * Mirrors @chaos/types/views runtime schemas — kept duplicated as TS
 * types so the component layer doesn't import the Zod payload (which
 * pulls in the runtime parser unnecessarily).
 */
import type { AutonomyLevel, Card } from '@chaos/types/kanban';
import type {
  CardListColumnId,
  CardListFilters,
  CardListGrouping,
  CardListSort,
  CardListSortDir,
  SavedListView,
} from '@chaos/types/views';

export type {
  AutonomyLevel,
  Card,
  CardListColumnId,
  CardListFilters,
  CardListGrouping,
  CardListSort,
  CardListSortDir,
  SavedListView,
};

/** Visible columns the List view supports out of the box. */
export const DEFAULT_VISIBLE_COLUMNS: readonly CardListColumnId[] = [
  'title',
  'status',
  'agent',
  'autonomy',
  'due',
  'last_activity',
];

export const ALL_COLUMNS: readonly CardListColumnId[] = [
  'title',
  'status',
  'agent',
  'autonomy',
  'progress',
  'due',
  'last_activity',
  'priority',
  'members',
  'cost_today',
];

export const COLUMN_LABELS: Record<CardListColumnId, string> = {
  title: 'Title',
  status: 'Status',
  agent: 'Agent',
  autonomy: 'Autonomy',
  progress: 'Progress',
  due: 'Due',
  last_activity: 'Last activity',
  priority: 'Priority',
  members: 'Members',
  cost_today: 'Cost today',
};
